import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

/** Persistent strip under the header when the browser reports offline. */
export function OfflineBanner() {
	const isOnline = useOnlineStatus();

	if (isOnline) return null;

	return (
		<output
			aria-live="polite"
			className="flex shrink-0 items-center justify-center gap-2 border-b border-[var(--color-status-invite-expired-bg)] bg-[var(--color-status-invite-expired-bg)] px-4 py-2 text-sm text-status-invite-expired"
		>
			<WifiOff className="h-4 w-4 shrink-0" aria-hidden />
			<span className="font-medium">
				You’re offline — some pages and actions won’t work until you reconnect.
			</span>
		</output>
	);
}
